<template>
  <div class="tasks-filter" v-click-outside="() => { this.isActive = false}">

    <div class="tasks-filter__header" :class="[{
      'tasks-filter__header--active': isActive
    }]" @click="isActive = true">
      <span v-if="selectedFilterText === 'Все'" class="mr-2">{{name}}:</span>

      <span class="tasks-filter__selected-value"> {{selectedFilterText}}</span>

      <feather-icon icon="ChevronDownIcon"/>
    </div>

    <ul class="tasks-filter__values" v-if="isActive">
      <vs-input icon-pack="feather"
                icon="icon-search"
                placeholder="Поиск..."
                v-model.trim="searchString"
                class="vs-input-no-border vs-input-border-bottom vs-input-no-shdow-focus no-icon-border w-full tasks-filter__values-search" />
      <VuePerfectScrollbar>
        <template v-if="filteredValues.length">
          <li v-for="filterValue in filteredValues" :key="filterValue[valueKey]" class="tasks-filter__values-value tasks-filter-value" :title="filterValue[label]">
            <vs-checkbox v-model="valueLocal" class="tasks-filter-value__checkbox" :vs-value="filterValue[valueKey]">{{filterValue[label]}}</vs-checkbox>
          </li>
        </template>
        <li v-else>
          <h6 class="text-center">Значений нет</h6>
        </li>
      </VuePerfectScrollbar>
    </ul>

  </div>
</template>

<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";

  export default {
    name: "TasksFilter",
    components: {VuePerfectScrollbar},
    props: {
      name: {
        required: true
      },
      value: {
        type: Array,
        required: true
      },
      values: {
        type: [Array, Object]
      },
      label: {
        type: String,
        default: 'name'
      },
      valueKey: {
        type: String,
        default: 'id'
      }
    },
    data(){
      return {
        searchString: '',
        isActive: false,
      }
    },
    computed: {
      filteredValues(){
        let search = this.searchString.trim().toLowerCase();

        let arr = Array.isArray(this.values) ? this.values : Object.values(this.values);

        if(search.length){
          return arr.filter(value => {
            return String(value[this.label]).trim().toLowerCase().includes(search);
          });
        }
        else{
          return arr;
        }

      },
      selectedFilterText(){
        if(!this.valueLocal.length){
          return 'Все';
        }
        else{
          let items = [];

          this.valueLocal.forEach(value => {
            let item = this.findFilterItemInValues(value);
            if(item){
              items.push(item[this.label]);
            }
          });
          return items.join(', ');
        }
      },
      valueLocal: {
        get(){
          return this.value;
        },
        set(value){
          this.$emit('input', value);
        }
      },

    },
    methods: {
      findFilterItemInValues(key){
        let arr = Array.isArray(this.values) ? this.values : Object.values(this.values);

        let foundItem = arr.find(value => {
          return value[this.valueKey] === key;
        });
        return foundItem || null;
      }
    }
  }
</script>

<style lang="scss">
  .tasks-filter{
    position: relative;
    display: inline-flex;

    &__header{
      display: flex;
      align-items: center;
      border-radius: 3px;
      padding: 5px 8px;
      cursor: pointer;

      &--active{
        background: rgba(var(--vs-primary),1);
        color: white;
      }


      svg{
        width: 18px;
        height: 18px;
      }
    }

    &__values{
      position: absolute;
      width: 300px;
      background: #fff;
      box-shadow: 0 4px 8px -2px rgba(9,30,66,.25), 0 0 1px rgba(9,30,66,.31);
      z-index: 999999;
      border-radius: 3px;
      left: 0;
      top: 100%;
      margin-top: 4px;
      padding-bottom: 8px;
      max-height: 280px;
      display: flex;
      flex-direction: column;

      &-value{
        /*padding: 6px 10px 6px;*/
      }

      &-search{
        margin-bottom: 8px;
        flex-shrink: 0;
      }
    }

    &__selected-value{
      max-width: 280px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .tasks-filter-value{

    &__checkbox{
      margin: 0;
      padding: 6px 10px 6px;

      .vs-checkbox--input{
        left: 0;
      }

      &:hover{
        background-color: #f4f5f7;
      }

      .vs-checkbox{
        width: 16px;
        height: 16px;

        i{
          font-size: 12px;
        }
      }

      .con-slot-label{
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
</style>
